import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {Loner} from "../../../Loner";
import {LonerSound} from "../../../sound/LonerSound";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerGameAssets} from "../../../LonerGameAssets";

/**
 * Created by Jerker Nord on 2022-11-10.
 */

export class LonerSSDIntroView extends PIXI.Container implements StageLayer {

    private _clickCallback:Function;
    private _button:ContinueButton;

    constructor() {
        super();
        this.name = "LonerSSDIntroView";
        this.init();
    }

    private init():void {
        this.visible = false;

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.alpha = 0;
        this.addChild(this._button);

        this.onResize();
    }

    public showFSIntro(callback:Function):void {
        this.onResize();
        let startDelay:number = 1;
        if(Loner.model.isRestore) {
            startDelay = 0;
        }
        const showFSIntroTL:gsap.core.Timeline = gsap.timeline({delay : startDelay});
        showFSIntroTL.add(() => {
            this._clickCallback = callback;
            this.visible = true;
            Loner.foregroundView.setMode(LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK);
            Loner.keypadPlugin.hide();
            Loner.xBetView.pauseRedDotBlinkTL();
        });
        showFSIntroTL.add([
            gsap.to(this._button, {duration : 0.4, alpha : 1}),
            gsap.timeline({delay : 0.234}).add(() => {
                Loner.soundPlayer.switchMusic(LonerSound.SSD_INTRO_MUSIC);
            })
        ]);
        showFSIntroTL.add(() => {
            this._button.enable(true);
            Loner.tvMessageView.hide();
        });
    }

    private onButtonClick():void {
        this._button.enable(false);
        Loner.soundPlayer.playSound(LonerSound.CONTINUE_BUTTON);
        if(Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.SSD_ACTIVATION)?.isPlaying){
            Loner.soundPlayer.stopSound(LonerSound.SSD_ACTIVATION);
        }
        const hideFSIntroTL:gsap.core.Timeline = gsap.timeline();
        Loner.soundPlayer.switchMusic(Loner.model.data.nextMode);
        hideFSIntroTL.add(() => {
            if(Loner.model.isRestore) {
                Loner.keypadPlugin.setZeroBetSpinCounter(Math.max(Loner.model.freespinsLeft, 0));
                Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, false, Loner.isWinBelowStake());
            } else {
                Loner.keypadPlugin.setZeroBetSpinCounter(Loner.model.freespinsLeft);
            }
        });
        hideFSIntroTL.add(()=>{
            Loner.ssdMainView.initAnimators();
        });
        hideFSIntroTL.add([
            ()=>Loner.ssdMainView.show(),
            gsap.to(this._button, {duration : 0.1, alpha : 0})
        ]);
        hideFSIntroTL.add(() => {
                Loner.allReelView.visible = false;
                Loner.allReelView.resetAllReels();
            }
        );
        //Small delay before FS starts
        hideFSIntroTL.add(gsap.timeline({delay : 0.2}));
        hideFSIntroTL.add(() => {
            Loner.keypadPlugin.show();
            this.visible = false;
            Loner.foregroundView.endForegroundSwitchTL();
            Loner.foregroundView.clearAnimationTrack(0);
            this._clickCallback();
        });
        hideFSIntroTL.add(Loner.ssdMainView.startTheDucks());
    }

    public onResize():void {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom:number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }
}